import { render, staticRenderFns } from "./MatchMode.vue?vue&type=template&id=e3c71fb0&scoped=true&"
import script from "./MatchMode.vue?vue&type=script&lang=js&"
export * from "./MatchMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c71fb0",
  null
  
)

export default component.exports